import { Routes } from '@angular/router';
import { GolfEventListComponent } from './components/golf-event-list/golf-event-list.component';
import { LeagueComponent } from './components/league/league.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/authguard';
import { PlayerAdminComponent } from './components/admin/player-admin/player-admin.component';
import { ProfileComponent } from './components/profile/profile.component';
import { BarnAvailabilityComponent } from './components/barn/barn-availability/barn-availability.component';

export const routes: Routes = [
    { path: '', redirectTo: 'events', pathMatch:'full' },
    { path: 'events', component: GolfEventListComponent, canActivate: [authGuard]  },
    { path: 'barn', component: BarnAvailabilityComponent, canActivate: [authGuard]  },
    { path: 'league/:id', component: LeagueComponent, canActivate: [authGuard]  },
    { path: 'login', component: LoginComponent  },
    { path: 'admin/players', component: PlayerAdminComponent, canActivate: [authGuard]},
    { path: 'profile', component: ProfileComponent, canActivate: [authGuard]},
];
